<template>
  <div
    id="skin-select"
    v-show="
      $route.hideNavigation === undefined || $route.hideNavigation == false
    "
  >
    <a id="toggle">
      <span class="fa icon-menu"></span>
    </a>

    <div class="skin-part">
      <div id="tree-wrap">
        <div id="menuwrapper" class="side-bar">
          <ul id="menu-showhide" class="topnav">

            <!-- Logged out menu -->
            <li v-if="authorized.access == null">
              <a class="tooltip-tip" href="https://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/awri-ferment-simulator">
                <div class="img-container" style="min-width:20px;display:inline-block;text-align:center;margin-right:10px;">
                  <img src='/static/img/i.png' style="height: 17px;"/>
                </div>
                <span>Overview</span>
              </a>
            </li>
            <li v-if="authorized.access == null">
              <a class="tooltip-tip" href="https://www.awri.com.au/industry_support/winemaking_resources">
                <div class="img-container" style="min-width:20px;display:inline-block;text-align:center;margin-right:10px;">
                  <img src='/static/img/wine.png' style="height: 17px;"/>
                </div>
                <span>Winemaking</span>
              </a>
            </li>
            <li v-if="authorized.access == null">
              <a class="tooltip-tip" href="https://www.awri.com.au/industry_support">
                <div class="img-container" style="min-width:20px;display:inline-block;text-align:center;margin-right:10px;">
                  <img src='/static/img/grape.png' style="height: 17px;"/>
                </div>
                <span>Services to industry</span>
              </a>
            </li>
            <li v-if="authorized.access == null">
              <a class="tooltip-tip" href="https://www.awri.com.au">
                <div class="img-container" style="min-width:20px;display:inline-block;text-align:center;margin-right:10px;">
                  <img src='/static/img/awri.png' style="height: 17px;"/>
                </div>
                <span>AWRI Home</span>
              </a>
            </li>
            <!-- END Logged out menu -->

            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'dashboard' }">
                <i class="fa fa-dashboard"></i>
                <span>Dashboard</span>
              </a>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" href="#">
                <i class="fa fa-database"></i>
                <span>Tank Groups</span>
              </a>
              <ul>
                <li v-for="tankGroup in tankGroups" :key="tankGroup.id">
                  <a
                    v-link="{
                      name: 'dashboard.tank-group',
                      params: { tankGroupId: tankGroup.id },
                    }"
                    >{{ tankGroup.name }}</a
                  >
                </li>
              </ul>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'history.index' }">
                <i class="fa fa-clock-o"></i>
                <span>History</span>
              </a>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'fermenters.index' }">
                <i class="fa fa-plus"></i>
                <span>Fermenter Setup</span>
              </a>
            </li>
            <li v-if="authorized.access > 10">
              <a class="tooltip-tip" v-link="{ name: 'profiles.index' }">
                <i class="fa fa-server"></i>
                <span>Ferment Profiles</span>
              </a>
            </li>
            <li v-if="authorized.access > 10">
              <a class="tooltip-tip" v-link="{ name: 'simulators.index' }">
                <i class="fa fa-line-chart"></i>
                <span>Simulator Setup</span>
              </a>
            </li>
            <li v-if="authorized.access == 30">
              <a class="tooltip-tip" v-link="{ name: 'settings.index' }">
                <i class="fa fa-cog"></i>
                <span>Admin Settings</span>
              </a>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'site-selection.index' }">
                <i class="fa fa-retweet"></i>
                <span>Change Site</span>
              </a>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'contact.index' }">
                <i class="fa fa-envelope"></i>
                <span>Contact</span>
              </a>
            </li>
            <li v-if="authorized.access != null">
              <a class="tooltip-tip" v-link="{ name: 'logout' }">
                <i class="fa fa-sign-out"></i>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tankGroups, authorized } from "vx/getters";

// Dodgy way of checking auth since it is managed elsewhere
var isAuthenticated = sessionStorage.getItem('token');

export default {
  data() {
    return {
      isAuthenticated: isAuthenticated
    };
  },

  ready() {
    $("#skin-select").affix({
      offset: 60,
    });
  },

  vuex: {
    getters: {
      tankGroups,
      authorized,
    },
  },
};
</script>

<style scoped>
.affix,
.affix-bottom {
  top: 0 !important;
  position: fixed !important;
}
</style>



// WEBPACK FOOTER //
// navigation.vue?017e3484